import { InjectionToken } from '@angular/core'

import { Observable } from 'rxjs'

export interface AppUpdateInfo {
  updateType: 'SERVICE_WORKER' | 'NATIVE_STORE'
  updateAvailability: 'UPDATE_AVAILABLE' | 'UPDATE_NOT_AVAILABLE' | 'UNKNOWN'
  availableVersion?: string
  clientVersionStalenessDays?: number
  currentVersion?: string
}

export interface IUpdateManager {
  readonly updateType: AppUpdateInfo['updateType']
  readonly versionReady$: Observable<AppUpdateInfo>
  execUpdate(): Promise<void>
  getAppUpdateInfo(): Promise<AppUpdateInfo>
}

export const UPDATE_MANAGER = new InjectionToken<IUpdateManager>('UPDATE_MANAGER')
